import { WebCrud } from '../../../containers/crud/webCrud';
import { Crud } from '../../../containers/crud/crud';
import { translate } from '../../../localization';
import { formatDate } from '@arivaa-react/helpers/date-util';
import { ExtraInfoComponent } from './extraInfoComponent';
import { useCrudRecord } from '../../../containers/crud/recordContext';

export default function WebsiteEnquiries({ match }) {
  return (
    <WebCrud api={`contact-form/website-enquiries/${match.params.websiteid}`}>
      <Crud.Header title="Website Enquiries">
        <Crud.Header.Actions>
          <Crud.Header.Actions.Refresh />
        </Crud.Header.Actions>
      </Crud.Header>
      <Crud.Table
        actions={[
          Crud.Table.RowActions.Delete,
          () => {
            const record = useCrudRecord();
            return <ExtraInfoComponent data={record} />;
          },
        ]}
        columns={[
          {
            title: translate('support.email.label'),
            dataIndex: ['info', 'email'],
          },
          {
            title: translate('support.name.label'),
            dataIndex: ['info', 'name'],
          },
          {
            title: translate('support.phone.label'),
            dataIndex: ['info', 'phone'],
          },
          {
            title: translate('support.contactedAt.label'),
            dataIndex: 'createdAt',
            render: (createdAt) => {
              return <p>{formatDate(createdAt)}</p>;
            },
          },
        ]}
      >
        <Crud.Table.TableActions.Common />
        <Crud.Table.Header>
          <Crud.Table.BulkRowActions.Common />
        </Crud.Table.Header>
      </Crud.Table>
    </WebCrud>
  );
}

WebsiteEnquiries.url = 'website-enquiries/:websiteid';
